<template>
  <v-card class="lesson-overview">
    <div v-show="ready">
      <v-btn
        fab
        small
        absolute
        top
        right
        class="close-button"
        @click="$emit('close-tab')"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-container>
        <v-row class="minus-gap">
          <v-col
            v-for="(lesson, index) in customClass.lessons"
            :key="index"
            lg="4"
            md="6"
            cols="12"
          >
            <lesson-card
              :userLessons="studentLessons"
              @startClassLesson="startClassLesson"
              student-list
              :lesson="lesson"
            ></lesson-card>
          </v-col>
          <v-col v-if="!customClass.lessons.length" xs12>
            <v-card flat>
              <v-card-text
                ><v-icon>info</v-icon
                >{{
                  ` Your class teacher haven\'t selected any lesson for you to take`
                }}</v-card-text
              >
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-show="!ready" class="text-center pa-5">
      <v-progress-circular
        :size="70"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
import _ from 'lodash'
import LessonCard from '@/modules/lesson/views/LessonCard'
import Auth from '@/modules/auth/models/Auth'
import Student from '@/modules/student/models/Student'
import Lesson from '@/modules/lesson/models/Lesson'

export default {
  name: 'Lessons',
  components: {
    LessonCard
  },
  props: {
    customClass: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      ready: false,
      studentLessons: null
    }
  },
  computed: {},
  async mounted() {
    this.$store.state.loading = true
    await Lesson.dispatch('fetch', this.$route.meta.type)

    const payload = {
      customClassId: this.customClass.id
    }

    const studentLessons = await Student.dispatch('fetchUserLessons', {
      payload: payload
    })

    const filteredStudentLessons = _.filter(studentLessons, el => {
      return el.is_completed === false
    })

    this.studentLessons = filteredStudentLessons
    this.$store.state.loading = false
    this.ready = true
  },
  methods: {
    redirectToLesson(lesson, slug = '') {
      let userLessonId = 0
      for (const index in this.studentLessons) {
        if (this.studentLessons[index].lesson_id === lesson.id)
          userLessonId = this.studentLessons[index].id
      }

      if (!userLessonId) {
        userLessonId = lesson.id
      }
      let link = ''
      let base_url = window.location.origin
      if (process.env.NODE_ENV === 'production') {
        link = 'lessons/student'
      } else {
        base_url = `${process.env.VUE_APP_LESSON}/student`
      }

      window.open(
        `${base_url}/${link}?slug=${slug}&user_lesson_id=${userLessonId}`
      )
    },

    async startClassLesson(lesson) {
      if (Auth.query().first().type === 'student') {
        const payload = {
          customClassId: this.customClass.id,
          slug: lesson.slug
        }

        try {
          const userLesson = await Student.dispatch('startClassLesson', {
            payload: payload
          })
          this.redirectToLesson(userLesson, userLesson.lesson.slug)
        } catch (error) {
          if (error.response.status === 422) {
            if (
              error.response.data.message ===
              'Lesson in progress for this class and this student.'
            ) {
              console.log('are you here')
              this.redirectToLesson(lesson, lesson.slug)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss"></style>
